module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/74a059c43e52a614bb6d873cd3a817b5.gif";